import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import type { RichLine, Segment } from '../page-content';
import { CfEmail } from './CfEmail';
function renderSegment(seg: Readonly<Segment>, idx: number) {
  switch (seg.kind) {
    case 'text':
      return <span key={idx}>{seg.text}</span>;
    case 'code':
      return <code key={idx}>{seg.text}</code>;
    case 'link':
      {
        const isInternal = seg.href.startsWith('/') && !seg.href.endsWith('/');
        const isInternalSlash = seg.href.startsWith('/') && seg.href.endsWith('/');
        // Next.js <Link> strips trailing slashes from internal hrefs; use a plain
        // <a> when the source URL ends with "/" to keep parity with the source manifest.
        if (isInternal) {
          return <Link key={idx} href={seg.href}>
            {seg.text}
          </Link>;
        }
        if (isInternalSlash) {
          return <a key={idx} href={seg.href}>
            {seg.text}
          </a>;
        }
        return <a key={idx} href={seg.href}>
          {seg.text}
        </a>;
      }
    case 'cfemail':
      return <CfEmail key={idx} cfemail={seg.cfemail} />;
  }
}
export function RichParagraph(t0) {
  const $ = _c(5);
  const {
    line,
    className
  } = t0;
  let t1;
  if ($[0] !== line.segments) {
    t1 = line.segments.map(renderSegment);
    $[0] = line.segments;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== className || $[3] !== t1) {
    t2 = <p className={className}>{t1}</p>;
    $[2] = className;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export function RichLines(t0) {
  const $ = _c(7);
  const {
    lines,
    className
  } = t0;
  let t1;
  if ($[0] !== className || $[1] !== lines) {
    let t2;
    if ($[3] !== className) {
      t2 = (line, i) => <RichParagraph key={i} line={line} className={className} />;
      $[3] = className;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = lines.map(t2);
    $[0] = className;
    $[1] = lines;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <>{t1}</>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}